import { Skeleton, Table } from "antd";

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({ rows = 5, columns = 4 }) => {
  const skeletonColumns = Array.from({ length: columns }, (_, i) => ({
    key: i,
    dataIndex: `col${i}`,
    render: () => <Skeleton.Input active size="small" block />,
  }));

  const skeletonData = Array.from({ length: rows }, (_, i) => ({
    key: i,
  }));

  return <Table columns={skeletonColumns} dataSource={skeletonData} pagination={false} />;
};
